// ─── Application Configuration ───────────────────────────────────────────────

export const API_URL = process.env.REACT_APP_API_URL;
export const API_VERSION = '/api/v1';
export const APP_NAME = 'Proud';
export const PANEL_NAME = 'Admin';

// ─── Regex Validators ─────────────────────────────────────────────────────────

export const EMAIL_REGEX = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/;
export const PASS_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
export const Numeric = /^[0-9]+$/;
export const ALPHABET = /^[A-Za-z]+$/;
export const ALPHANUMERIC_REGEX = /[^a-z\d]/i;
export const PASS_VALIDATION_MSG =
  'password should be at least 8 characters, one uppercase, lowercase, special character, numeric value.';

/**
 * @deprecated API_TOKEN is computed once at module load time and will be stale
 * after login. Use localStorage.getItem('token') directly at the call site,
 * or rely on Axios.js which reads the token fresh on every request.
 */
export const API_TOKEN = localStorage.getItem('user_id');
